module.exports = __webpack_public_path__ + "static/img/AI_heading.b0d8f560.png";